<template v-if="ready">
    <div class="mt-2">
        <div class="container-fluid border">
            <div class="row">
                <div class="col-md-3">
                    <div class="mt-2">
                        <label>{{ $t('datasource') }}: </label>
                    </div>
                    <div>
                        <select v-model="currentDataSource" class="w-100" @change="reloadChart()">
                            <option v-for="source in dataSources" v-bind:value="source">
                                {{ source }}
                            </option>
                        </select>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="mt-2">
                        <label>{{ $t('timerange') }}: </label>
                    </div>
                    <div>
                        <select v-model="currentSelectedTimerange" class="w-100" @change="reloadChart()">
                            <option v-for="(timerangeName, timerange) in availableTimeranges" v-bind:value="timerange"
                            >
                                {{ timerangeName }}
                            </option>
                        </select>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="mt-2">
                        <label>{{ $t('Aggregation') }}: </label>
                    </div>
                    <div>
                        <select v-model="currentAggregation" class="w-100" @change="reloadChart()">
                            <option v-for="(aggregationName, aggregation) in availableAggregations"
                                    v-bind:value="aggregation">
                                {{ aggregationName }}
                            </option>
                        </select>
                    </div>
                </div>

                <div class="col-md-3">
                    <div class="mt-2 text-end">
                        <button type="button" class="btn btn-light btn-sm" @click="reloadChart()">
                            <i class="fa-solid fa-arrows-rotate"></i> Reload
                        </button>
                    </div>
                </div>
                <div style="position: relative;height:350px;">
                   <!-- <canvas id="canvas" ref="canvas"></canvas>-->

                        <v-chart v-if="ready" ref="vechart" :theme="theme" :option="option"  @datazoom="onChartDataZoom($event)" @finished="onChartFinished($event)"  autoresize/>

                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { DateTime } from "luxon";
import "echarts";
import VChart from 'vue-echarts';
export default {
    name: "ServiceGraphEcharts",
    components: {
         VChart
    },
    data() {
        return {
            ready: false,
            theme: this.$store.state.theme,
            hostuuid: '',
            serviceuuid: '',
            mergedService: [],
            timezone: {},
            serverTimeDateObject: {},
            lastTimestampWithData: new Date(),
            ServerTime: new Date(),
            autorefresh: false,
            autoRefreshIntervalId: null,
            currentSelectedTimerange: 3,
            graphStart: 0,
            graphEnd: 0,
            config: {
                showDataPoint: false,
                smooth: true,
                autoRefresh: true
            },
            zoomEnabled: false,
            availableTimeranges: {
                1: '1 hour',
                3: '3 hours',
                8: '8 hours',
                24: '1 day',
                168: '7 days',
                720: '30 days',
                2160: '90 days',
                4320: '6 month'
            },
            currentAggregation: 'avg',
            availableAggregations: {
                avg: 'Average',
                min: 'Minimum',
                max: 'Maximum'
            },
            dataSources: [],
            currentDataSource: '',
            currentGraphUnit: null,
            currentTimerange:  {start: 0, end: 0},
            perfData: {},
            chartOption: {},
            option: {},
            gaugeData: {},
            timerangePlaceholder: null,

        }
    },

    mounted() {
       // this.theme = this.$store.state.theme;
        this.getTimezone();

    },
    methods: {
        reloadChart() {
            this.zoomEnabled = false; // After a re-render we have to re-enable the zoom
            this.currentGraphUnit = null; // Reset the unit to get the new one from the API
            this.loadPerfData();
        },

        getTimezone: function() {
            axios.post('/downtimes/get_timezone_object.json').then(response => {
                this.timezone = response.data.timezone.timezone;
                this.serverTimeDateObject = new Date(this.timezone.server_time_iso);
            }).catch(error => {
                console.log('Could not fetch timezone');
            });
        },
        getGraphData(host, service, merged){
            this.hostuuid = host;
            this.serviceuuid = service;
            this.mergedService = merged;
            this.setDataSources();
            this.loadPerfData();
        },
        setDataSources(){
            this.dataSources = [];
            for(var dsName in this.mergedService.Perfdata){
                this.dataSources.push(dsName);
            }
            /* if(this.mergedService.service_type === 32){
                 this.dataSources = [this.mergedService.name];
             } */
            if(this.dataSources.length > 0 && this.currentDataSource === ''){
                this.currentDataSource = this.dataSources[0];
            }
        },
        loadPerfData: function() {
            if (this.dataSources.length === 0) {
                // This service has no datasources
                return;
            }

            if(this.dataSources.length > 0 && this.currentDataSource === '') {
                this.currentDataSource = this.dataSources[0];
            }
            if (this.currentSelectedTimerange > 0) {
                // Initial value or the user selected a timerange from the dropdown
                this.timerangePlaceholder = null;
                this.currentTimerange = this.getStartEndEndTimestampsBySelectedTimerange();
            }
            let payload = {
                angular: true,
                service_uuid: this.serviceuuid,
                host_uuid: this.hostuuid,
                start: this.currentTimerange.start,
                end: this.currentTimerange.end,
                jsTimestamp: 0,
                isoTimestamp: 1,
                gauge: this.currentDataSource,
                aggregation: this.currentAggregation,
            };
            if (this.currentGraphUnit !== null) {
                // Append new data in the same unit
                payload.forcedUnit = this.currentGraphUnit;
            }
            axios.post('/services/perfdata.json', payload)
                .then(response => {
                    this.perfData = response.data.perfdata.performance;
                    const datasource = this.perfData[0].datasource;
                    if (this.currentGraphUnit === null) {
                        // First load of data - save the unit we got
                        this.currentGraphUnit = this.perfData[0].datasource.unit;
                    }
                    for (const isoTimestamp in this.perfData[0].data) {
                        let timestamp = new Date(isoTimestamp);
                        if (timestamp > this.lastTimestampWithData) {
                            this.lastTimestampWithData = timestamp;
                        }
                    }
                    this.renderChart();

                })
        },
        renderChart:  function() {
            this.ready = false;
            let gauge = this.perfData[0];
            let data = [];
            // Data format for eCharts
            // https://stackoverflow.com/a/68461548
            for(let isoTimestamp in gauge.data) {
                data.push([isoTimestamp, gauge.data[isoTimestamp]]);
            }
            this.option = {
                backgroundColor: 'transparent',
                height: 150,
                width: '100%',
                title: {
                    text: (this.timerangePlaceholder !== null) ? this.truncateShort(gauge.datasource.name) + ' / ' + this.timerangePlaceholder : this.truncateTitle(gauge.datasource.name) + ' / ' + this.availableTimeranges[this.currentSelectedTimerange],
                    left: 'center',
                    top: 3,
                    bottom: 3,
                    overflow: 'truncate',
                    ellipsis: '...',
                    textStyle: {
                        fontSize: 14,
                        fontWeight: 'bold',
                        overflow: 'truncate',
                        ellipsis: '...',
                    }
                },
               /* legend: {
                    data: [gauge.datasource.name],
                    textStyle: {
                        fontSize: '12px',
                        size: 20
                    },
                    icon: 'path://',
                },*/
                tooltip: {
                    show: true,
                    trigger: 'axis',
                    formatter: (params) => {
                        // Maybe add a loop if we want to support multiple gauges in one chart
                        const gauge = params[0];
                        //const dateTime = DateTime.fromMillis(gauge.data[0]).setZone(this.timezone.user_timezone);
                        const dateTime = DateTime.fromISO(gauge.data[0]).setZone(this.timezone.user_timezone);
                        const value = gauge.data[1];
                        const seriesName = this.truncateShort(gauge.seriesName);
                        const color =  gauge.color;
                        const marker = params[0].marker;
                        return `${marker} ${seriesName}<br />
                        ${dateTime.toFormat('dd.MM HH:mm')}<br />
                        ${value} ${this.currentGraphUnit ? this.currentGraphUnit : ''}`;
                    }

                },
                xAxis: {
                    type: 'time',
                    min: new Date(this.currentTimerange.start * 1000).toISOString(),
                    axisLabel: {
                        rotate: 45,
                        hideOverlap: true,
                        formatter: (value) => {
                            const dateTime = DateTime.fromMillis(value).setZone(this.timezone.user_timezone);
                            return dateTime.toFormat('dd.LL HH:mm');
                        }
                    },
                    splitLine: {
                        show: true,
                    },
                    axisTick: {
                        show: true,
                    },
                    minorSplitLine: {
                        show: false
                    }
                },
                yAxis: {
                    type: 'value',
                    axisLabel: {
                        formatter: (value) => {
                            return `${value} ${this.currentGraphUnit ? this.currentGraphUnit : ''}`
                        }
                    },
                    minorTick: {
                        show: false
                    },
                    minorSplitLine: {
                        show: false
                    }
                },
                dataset: {
                    source: data,
                    dimensions: ['timestamp', gauge.datasource.name],
                },
                series: [
                    {
                        name: gauge.datasource.name,
                        type: 'line',
                        /*minorTick: {
                            show: true
                        },
                        minorSplitLine: {
                            show: true
                        } , */
                        lineStyle: {
                            width: 2,
                            //color: 'rgb(88,86,214)',
                        },

                        encode: {
                            x: 'timestamp',
                            y: gauge.datasource.name // refer gauge (rta) value
                        },
                        smooth: this.config.showDataPoint,
                        showSymbol: this.config.showDataPoint, // Show/hide the dots on the line
                        areaStyle: {
                            opacity: 0.2
                        },
                    },
                ],

                grid: {
                    left: 50,
                    right: 20,
                    top: 25,
                    bottom: 50
                },
                toolbox: {
                  //  orient: 'vertical',
                  //  itemSize: 13,
                  //  top: 15,
                   // right: -6,
                    orient: 'horizontal',
                    itemSize: 3,
                    top: 5,
                    left:5,
                    feature: {
                        dataZoom: {
                            yAxisIndex: 'none',
                            icon: {
                                zoom: 'path://', // hack to remove zoom button
                                back: 'path://', // hack to remove restore button
                            },
                        },
                    },
                },
            };

            this.gaugeData = gauge;

            let thresholds = this.getThresholds(gauge);
            if (thresholds) {
                this.option.visualMap = thresholds;
            } else {

                this.option.series[0].lineStyle.color = '#4285F4'; //'rgb(88,86,214)';
            }
            this.ready = true;
        },

        getThresholds(gauge) {

            let pieces = []; // VisualPiece is not public

            switch(gauge.datasource.setup.scale.type) {
                case 'O':
                    // We do not have any thresholds
                    break;

                case 'W<O':
                    // ✅
                    pieces.push({
                        lte: gauge.datasource?.setup.warn.low, // -3
                        color: 'rgba(234, 184, 57, 1)'
                    });

                    // +0.00001 because a bug in echarts that does not render if both values are the same
                    // https://github.com/apache/echarts/issues/18948
                    // https://echarts.apache.org/examples/en/editor.html?c=line-simple&code=PYBwLglsB2AEC8sDeAoWsCeBBAHhAzgFzIC-ANGrDrgcUrGBiAKbEDkAxgIZjMDmwAE4Y2scpXzNBEZkVgBtSulTpVDJq1hsANhGjM2ZWLv0BlRts30A7hAAmYABbEArGIpr0XQcy7mMlnQkSmKUALoesHY8XJJgxIpqKp52EAC2zND4UFkJbBi-goZaIILAAGYQYGwRIej4wACughyaiZ7KdZ4F3uwATAAMAIwDhl1qpRVVxCMD4-7zyR3oPYL9w0Njy6qTlfGwg3Pb4ttLy6vrQ31b27C707AAtEMuR8sny2cdF1qDQwDMN22932_wGbw6wQ6YRCUNgtXQADcCI0uNoALJcEAJEJfBigVwDSJqaR8Rz7IldEAyVpydodejaXjER4DAB04OGRg4wG0QnYPjsog-HQA9KLYGi0sB8GBYPhGhxWsw7PjYI57MwGI4tQAvKTAYxcABGzG0i1gfH2rI54KGRiZxHZnPtsB5fLWWjAgi4WRA3ky1QdJrN7C0Is89Ctmmddu5vP5WmN2kaBlC0OJqiaYAA8uUAEq-vhWebuxNsADEADZmDWa2wunD0HCYSQANxAA
                    pieces.push({
                        gt: ( Number(gauge.datasource?.setup.warn.low) + 0.00001 ), // -3
                        color: 'rgba(86, 166, 75, 1)'
                    });

                    break;

                case 'C<W<O':
                    // ✅

                    pieces.push({
                        lte: gauge.datasource?.setup.crit.low, // -5
                        color: 'rgba(224, 47, 68, 1)'
                    });

                    pieces.push({
                        gt: gauge.datasource?.setup.crit.low, // -5
                        lte: gauge.datasource?.setup.warn.low, // -3
                        color: 'rgba(234, 184, 57, 1)'
                    });

                    pieces.push({
                        gt: gauge.datasource?.setup.warn.low, // -3
                        color: 'rgba(86, 166, 75, 1)'
                    });
                    break;


                case 'O<W':
                    // ✅
                    pieces.push({
                        lt: gauge.datasource?.setup.warn.high, // 3
                        color: 'rgba(86, 166, 75, 1)'
                    });

                    // +0.00001 because a bug in echarts that does not render if both values are the same
                    pieces.push({
                        gte: Number(gauge.datasource?.setup.warn.high) + 0.00001, // 3
                        color: 'rgba(234, 184, 57, 1)'

                    });
                    break;

                case 'O<W<C':
                    // ✅
                    if(gauge.datasource?.setup.warn.low === gauge.datasource?.setup.crit.low) {
                        // If all values are the zero, this breaks the gradient
                        break;
                    }

                    pieces.push({
                        lt: gauge.datasource?.setup.warn.low, // 3
                        color: 'rgba(86, 166, 75, 1)'
                    });

                    pieces.push({
                        gte: gauge.datasource?.setup.warn.low, // 3
                        lt: gauge.datasource?.setup.crit.low, // 5
                        color: 'rgba(234, 184, 57, 1)'
                    });

                    pieces.push({
                        gte: gauge.datasource?.setup.crit.low, // 5
                        color: 'rgba(224, 47, 68, 1)'
                    });
                    break;

                case 'C<W<O<W<C':
                    // ✅
                    let green = ( Number(gauge.datasource.setup.warn.high) + Number(gauge.datasource.setup.warn.low) ) / 2;

                    pieces.push({
                        lte: gauge.datasource?.setup.crit.low, // -5
                        color: 'rgba(224, 47, 68, 1)'
                    });

                    pieces.push({
                        lte: gauge.datasource?.setup.warn.low, // -3
                        color: 'rgba(234, 184, 57, 1)'
                    });

                    pieces.push({
                        gt: gauge.datasource?.setup.warn.low, // -3
                        lt: gauge.datasource?.setup.warn.high, // 3
                        color: 'rgba(86, 166, 75, 1)'
                    });

                    pieces.push({
                        gte: gauge.datasource?.setup.warn.high, // 3
                        lt: gauge.datasource?.setup.crit.high, // 5
                        color: 'rgba(234, 184, 57, 1)'
                    });

                    pieces.push({
                        gte: gauge.datasource?.setup.crit.high, // 5
                        color: 'rgba(224, 47, 68, 1)'
                    });
                    break;


                case 'O<W<C<W<O':
                    // ✅

                    pieces.push({
                        lt: gauge.datasource?.setup.warn.low, // -5
                        color: 'rgba(86, 166, 75, 1)'
                    });

                    pieces.push({
                        gte: gauge.datasource?.setup.warn.low, // -5
                        lt: gauge.datasource?.setup.crit.low, // -3
                        color: 'rgba(234, 184, 57, 1)'
                    });

                    pieces.push({
                        gte: gauge.datasource?.setup.crit.low, // -3
                        lte: gauge.datasource?.setup.crit.high, // 3
                        color: 'rgba(224, 47, 68, 1)'
                    });

                    pieces.push({
                        gt: gauge.datasource?.setup.crit.high, // 3
                        lte: gauge.datasource?.setup.warn.high, // 5
                        color: 'rgba(234, 184, 57, 1)'
                    });

                    pieces.push({
                        gt: gauge.datasource?.setup.warn.high, // 5
                        color: 'rgba(86, 166, 75, 1)'
                    });
                    break;
            }


            /*  let cssSecondaryBg = getComputedStyle(document.documentElement).getPropertyValue('--cui-secondary-bg').trim();
              // Add some transparency to the background color
              cssSecondaryBg += '66'; */

            if(pieces.length > 0) {
                return {
                    show: true,
                    top: 50,
                    right: 10,
                    pieces: pieces,
                    // backgroundColor: cssSecondaryBg,
                    outOfRange: {
                        color: 'rgba(204, 204, 204, 0.6)'
                    }
                };
            }

            return false;
        },

        onChartDataZoom(event) {
            const start = Math.floor(event.batch[0].startValue / 1000);
            const end = Math.floor(event.batch[0].endValue / 1000);

            // Set selectedTimerange to zero to get the placeholder displayed in the select
            // and to tell the loadPerfdata() method that we want to use the provided start/end timestamps
            this.currentSelectedTimerange = 0;


            this.currentTimerange = {start, end};

            const duration = end - start;
            this.timerangePlaceholder = `${this.getDateFormatted(start, duration)} - ${this.getDateFormatted(end, duration)}`;



            const now = new Date();
            const currentTimestamp = Math.floor(now.getTime() / 1000);


            // Reload detailed data
            this.zoomEnabled = false; // After a re-render we have to re-enable the zoom


            this.loadPerfData();
        },
        onChartFinished(event) {
            // Disable the animation after the chart is rendered

            // This is a workaround, to enable zooming after the chart is rendered
            // https://github.com/apache/echarts/issues/13397#issuecomment-814864873
            if (!this.zoomEnabled) {
                setTimeout(() => {
                    this.zoomEnabled = true;
                    this.$refs.vechart.dispatchAction({
                        type: 'takeGlobalCursor',
                        key: 'dataZoomSelect',
                        dataZoomSelectActive: true,
                    });
                }, 250);
            }
        },
        updateChart() {
            if(this.option && this.option.series) {

                this.option.series[0].smooth = this.config.smooth;
                this.option.series[0].showSymbol = this.config.showDataPoint;

                this.$refs.vechart.setOption(this.option);
            }
        },
        getDateFormatted(timestamp, duration = 0) {
            let dateTime = DateTime.fromSeconds(timestamp);

            if (duration < (3600)) {
                // Duration is less than 60 minutes - be more precise
                // Example: 10:20:42 - 10:37:25
                return dateTime.toFormat('HH:mm:ss');
            } else if (duration < (3600 * 24)) {
                // Duration is less than 24h
                // Example: Mon 9, 10:01 - Mon 9, 17:18
                return dateTime.toFormat('EEE d, HH:mm');
            } else if (duration < (3600 * 24 * 30)) {
                // Duration is less than 30 days
                // Example: 17.08 06:49 - 30.08 07:38
                return dateTime.toFormat('dd.MM HH:mm');
            }

            // Example: 13.09.2023 16:00 - 05.09.2024 10:09
            return dateTime.toFormat('dd.MM.yyyy HH:mm');
        },

        getStartEndEndTimestampsBySelectedTimerange() {
            const now = new Date();

            if (!this.timezone) {
                console.log('No timezone initialized - using defaults');

                const end = Math.floor(now.getTime() / 1000);
                const start = Math.floor((end - (this.currentSelectedTimerange * 3600)));
                return {start, end};
            }

            let offset = now.getTime() - this.serverTimeDateObject.getTime();
            if (offset < 0) {
                offset = 0;
            }

            const start = (Math.floor(this.serverTimeDateObject.getTime() / 1000) - (this.currentSelectedTimerange * 3600));
            const end = Math.floor((this.serverTimeDateObject.getTime() + offset) / 1000);

            return {start, end};
        },
        truncateTitle(title) {
            if (title.length > 25) {
                return title.substring(0, 22) + '...';
            }
            return title;
        },
        truncateShort(title) {
            if (title.length > 15) {
                return title.substring(0, 12) + '...';
            }
            return title;
        },

    },
    watch: {
        "$store.state.theme" : function() {
            this.theme = this.$store.state.theme;
        },

    }
}
</script>



<style scoped>

</style>
